import * as React from "react";

import { SortColumn, SortDirection } from "../api";

import { TableMenuItem as MenuItem, TableMenu } from ".";

type Props = {
  confirm: () => void;
  columnKey: string;
  setSortedColumn: (value: SortColumn) => void;
};

export const SortDropdown: React.FC<Props> = ({ confirm, columnKey, setSortedColumn }) => {
  return (
    <TableMenu>
      <MenuItem
        onClick={() => {
          setSortedColumn({ columnKey, value: SortDirection.ascend });
          confirm();
        }}
      >
        <span>Sort ASC </span>
      </MenuItem>

      <MenuItem
        onClick={() => {
          setSortedColumn({ columnKey, value: SortDirection.descend });
          confirm();
        }}
      >
        <span>Sort DESC</span>
      </MenuItem>
    </TableMenu>
  );
};
